import React, { useState, useContext } from 'react';
import useCommonStyles from '../../../../../commonStyles';
import { Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Grid, Button } from '@mui/material';
import { Typography } from '@mui/material';
import { TPVAST_CONSTANTS, PLATFORMS } from '../../../../../core/constants';
import { validGamUprFloorValues } from '../../../../../core/constants/gamUprConstants';

import { Modalv2Context } from '../../../../../Contexts/Modalv2Context';
import Popper from '@mui/material/Popper';
import Autocomplete from '@mui/material/Autocomplete';
import DropDownSingle from '../../../../../Components/DropDownSingle';

const { DESKTOP, MOBILE, TABLET, DEFAULT } = PLATFORMS;
const allPlatforms = [DEFAULT, DESKTOP, MOBILE, TABLET];
const validFloorValues = [...validGamUprFloorValues];
validFloorValues.push('DEFAULT');

/**
 * @name ModalAddNewInventoryValue  The function `ModalAddNewInventoryValue` renders a list of values based on the type of inventory, it also adds the new inventory value to the tpVastConfig object.
 */
const ModalAddNewInventoryValue = ({
	inventoryType,
	tpVastDoc,
	updateTpVastDoc,
	selectedTpValues
}) => {
	const { updateModalContent } = useContext(Modalv2Context);
	const commonStyleClasses = useCommonStyles();
	const [inventoryValue, setInventoryValue] = useState();
	const { FLOOR, DEMAND, PLATFORM } = TPVAST_CONSTANTS.INVENTORY;

	let selectList;
	if (inventoryType === FLOOR) {
		selectList = validFloorValues.filter((value) => {
			let floors = Object.keys(tpVastDoc);
			return !floors.includes(value);
		});
	}
	if (inventoryType === DEMAND) {
		selectList = TPVAST_CONSTANTS.THIRD_PARTY_DEMAND_PARTNERS.filter((value) => {
			let demands = Object.keys(tpVastDoc[selectedTpValues[FLOOR]]);
			return !demands.includes(value);
		});
	}
	if (inventoryType === PLATFORM) {
		selectList = allPlatforms.filter((value) => {
			let platforms = tpVastDoc[selectedTpValues[FLOOR]][selectedTpValues[DEMAND]];
			let platformArray = Object.keys(platforms);
			return !platformArray.includes(value);
		});
	}

	/**
	 * @name addNewInventoryValue The function `addNewInventoryValue` checks for existing inventory value and adds if not already exist.
	 * @param {String} type - Inventory type for ex:- floor, demand or platform.
	 * @param {String} value -  value for that inventory type.
	 */
	const addNewInventoryValue = (type, value) => {
		let newObj = structuredClone(tpVastDoc);
		if (type === FLOOR) {
			newObj[value] = {};
		}
		if (type === DEMAND) {
			newObj[selectedTpValues[FLOOR]][value] = {};
		}
		if (type === PLATFORM) {
			newObj[selectedTpValues[FLOOR]][selectedTpValues[DEMAND]][value] = [];
		}
		updateTpVastDoc(newObj);
	};

	return (
		<Box
			className={commonStyleClasses.modalContentStyle}
			style={{ width: '20rem', height: 'fit-content' }}
		>
			<Typography
				className={commonStyleClasses.heading}
				fontWeight={600}
				variant="h4"
				style={{ textAlign: 'center', margin: '1rem' }}
			>
				Add New {inventoryType}
			</Typography>
			<Grid container spacing={4}>
				<Grid item xs={12}>
					<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h5">
						{inventoryType}
					</Typography>
					{inventoryType === FLOOR ? (
						<Autocomplete
							value={inventoryValue}
							onChange={(event, newValue) => {
								setInventoryValue(newValue);
							}}
							id="number-input"
							freeSolo={false}
							options={selectList}
							sx={{ width: 250 }}
							style={{ margin: '1rem auto' }}
							PopperComponent={(props) => (
								<Popper {...props} style={{ transition: 'none', width: '250px' }} />
							)}
							renderInput={(params) => <TextField {...params} label="Select" variant="outlined" />}
						/>
					) : (
						<DropDownSingle
							isObjectEditor={false}
							list={selectList}
							directValue={inventoryValue}
							updateDirectValue={(newValue) => setInventoryValue(newValue)}
							formControlStyles={{ width: '30rem' }}
						/>
					)}
				</Grid>
			</Grid>
			<Grid
				item
				xs={12}
				style={{
					display: 'flex',
					justifyContent: 'center'
				}}
			>
				<Button
					variant="contained"
					style={{
						margin: '1rem auto'
					}}
					onClick={() => {
						if (inventoryValue) {
							addNewInventoryValue(inventoryType, inventoryValue);
							updateModalContent(null);
						}
					}}
				>
					Add
				</Button>
			</Grid>
		</Box>
	);
};

export default ModalAddNewInventoryValue;
